import html2canvas from "html2canvas-pro";
import jsPDF from "jspdf";

export async function downloadPatientHistoryPdf(
  element: HTMLElement,
  patient: { firstName?: string; lastName?: string } | null,
): Promise<void> {
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: "#ffffff",
    width: 595,
  });

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "pt",
    format: [595, 842],
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const paddingX = 15;
  const paddingY = 10;
  const footerHeight = 44;
  const headerHeight = 0;
  const contentStartY = paddingY + headerHeight;
  const contentHeight = pageHeight - contentStartY - footerHeight;
  const contentWidth = pageWidth - paddingX * 2;

  const imgWidth = contentWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
  let heightLeft = imgHeight;
  let position = 0;
  let page = 0;

  while (heightLeft > 0) {
    if (page > 0) pdf.addPage();

    const sourceY = position * (canvas.width / imgWidth);
    const sourceHeight = Math.min(
      contentHeight * (canvas.width / imgWidth),
      canvas.height - sourceY,
    );

    if (sourceHeight > 0) {
      const tempCanvas = document.createElement("canvas");
      tempCanvas.width = canvas.width;
      tempCanvas.height = sourceHeight;
      const tempCtx = tempCanvas.getContext("2d");
      if (tempCtx) {
        tempCtx.drawImage(
          canvas,
          0,
          sourceY,
          canvas.width,
          sourceHeight,
          0,
          0,
          canvas.width,
          sourceHeight,
        );
        const pageImgHeight = Math.min(contentHeight, heightLeft);
        pdf.addImage(
          tempCanvas.toDataURL("image/jpeg", 0.98),
          "JPEG",
          paddingX,
          contentStartY,
          imgWidth,
          pageImgHeight,
        );
      }
    }

    heightLeft -= contentHeight;
    position += contentHeight;
    page += 1;
  }

  const patientName =
    `${patient?.firstName || ""} ${patient?.lastName || ""}`.trim() || "Patient";
  pdf.save(
    `PatientHistory_${patientName.replace(/\s+/g, "_")}_${new Date().toISOString().slice(0, 10)}.pdf`,
  );
}
